import { useSelectedCoreLocationId } from '@elva/platform';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { growthKeys } from '@/data/queryKeys';

export function useLocationInvalidation() {
  const locationId = useSelectedCoreLocationId();
  const prevRef = useRef<number | undefined>(undefined);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (prevRef.current != null && prevRef.current !== locationId && locationId != null) {
      void queryClient.invalidateQueries({ queryKey: growthKeys.all });
    }
    prevRef.current = locationId;
  }, [locationId, queryClient]);
}
